import { ClerkProvider } from "@clerk/clerk-react";
import { LoadScript } from "@react-google-maps/api";
import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { AppContextProvider } from "./context/AppContext";
import { DeviceSettingsContextProvider } from "./context/DeviceSettingsContext";
import { NotificationContextProvider } from "./context/NotificationContext";
import "./index.css";
import DashboardPage from "./pages/DashboardPage";
import DevicePage from "./pages/DeviceDetailPage";
import DevicesListPage from "./pages/DevicesListPage";
import Layout from "./pages/Layout.tsx";
import LocationsPage from "./pages/LocationsPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import UsersPage from "./pages/UsersPage";
import reportWebVitals from "./reportWebVitals";
import AdminPage from "./pages/admin/AdminPage";
import AdminDevicePage from "./pages/admin/AdminDevicePage";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route index element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/" element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="locations" element={<LocationsPage />} />
        <Route path="devices" element={<DevicesListPage />} />
        <Route path="devices/:deviceId" element={<DevicePage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="admin/:account_id/devices" element={<AdminDevicePage />} />
      </Route>
    </>
  )
);

// Import your publishable key
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
      <AppContextProvider>
        <NotificationContextProvider>
          <DeviceSettingsContextProvider>
            <RouterProvider router={router} />
          </DeviceSettingsContextProvider>
        </NotificationContextProvider>
      </AppContextProvider>
    </ClerkProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
